"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[4664],{

/***/ 94664:
/***/ ((module) => {

module.exports = JSON.parse('{"saved":"Saved","newCloudDatabaseCreated":"A new company has been created for the client","clientIsImportedToFirmSupport":"The client has been imported into Workflow"}');

/***/ })

}]);